import { IInvalidConditionValue } from "Global/Base/Exceptions";

/** Výstup validátoru podmínek */
export interface IConditionValidationResult {
    /** Validní podmínka bez lokalizovaných atributů */
    readonly validCondition?: string;
    /** Nevalidní části podmínky */
    readonly invalidValues?: ReadonlyArray<IInvalidConditionValue>;
    /** Zda je podmínka validní */
    readonly isValid?: boolean;
}

/** Pár název atributu / jeho lokalizovaná verze zobrazená uživateli */
export interface ILocalizedAttributeData {
    [localizedName: string]: string;
}
